export const STORES_APP_DEF_ID = '215238eb-22a5-4c36-9e7b-e7c08025e04e';

export const WIX_META_SITE_ID_HEADER = 'x-wix-msid';
